import React from "react";
import Input from "../../../components/FormComponents/Input";

const BasicFormSettings = ({ data, onChange }) => {
  const handleChange = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  const handleStyleChange = (e) => {
    const { name, value } = e.target;
    onChange({
      ...data,
      style: {
        ...data.style,
        [name]: value
      }
    });
  };

  const handleResetChange = (e) => {
    const { name, type, checked, value } = e.target;
    onChange({
      ...data,
      reset_button: {
        ...data.reset_button,
        [name]: type === "checkbox" ? checked : value
      }
    });
  };

  const handlePositionedFormChange = (e) => {
    handleChange("is_positioned_form", e.target.checked);
  };

  return (
    <div className="builder_form">
      <Input label="Form name" type="text" value={data.name} onChange={(e) => handleChange("name", e.target.value)} />

      <Input
        label="Submit button"
        type="text"
        value={data.submit_button}
        onChange={(e) => handleChange("submit_button", e.target.value)}
      />

      <Input
        label="Min Width (in pX)"
        type="number"
        value={data.style.min_width}
        name="min_width"
        onChange={handleStyleChange}
      />

      <Input label="Width (in VW)" type="number" value={data.style.width} name="width" onChange={handleStyleChange} />

      <Input
        label="Max Width (in pX)"
        type="number"
        value={data.style.max_width}
        name="max_width"
        onChange={handleStyleChange}
      />

      <Input
        type="checkbox"
        label="Is Positioned Form"
        checked={data.is_positioned_form}
        name="is_positioned_form"
        onChange={handlePositionedFormChange}
      />

      <Input
        type="checkbox"
        label="Show reset button"
        checked={data.reset_button?.show_reset}
        name="show_reset"
        onChange={handleResetChange}
      />

      {data.reset_button?.show_reset && (
        <Input
          label="Reset Button"
          type="text"
          value={data.reset_button?.reset_label}
          name="reset_label"
          onChange={handleResetChange}
        />
      )}
    </div>
  );
};

export default BasicFormSettings;
